// removed by extract-text-webpack-plugin
module.exports = {"scope":"_2Wwv4LOmKAQFxOz2OWjCYS","content":"_1IxR5d945R1gFAp9vnP1QC","ratio1x1":"_2Bs6BPE5kJslHfDhtp3-ci","ratio2x1":"_3Dk_yEvctSpzb5rW2AIfrB","ratio3x1":"_2DUu9pWhEbJSK51iVAQokV","center":"_3fJsAPvHmRlmq2T72ncvrp","top":"_3S19h8olErHSiQvOGJqvbY","bottom":"_3JzkbotRZeBzeLBugEaQrQ","container":"mhGw3VEK7JbS3EDHri05e"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/AspectRatio/style.css
// module id = 245
// module chunks = 42